module.exports = __webpack_public_path__ + "img/ch25.2fd33f64.png";